exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.loading-spacer {\n\tmin-height: 5rem;\n}\n", "", {"version":3,"sources":["C:/Users/fmairess/workspace/lab/wow/vue/src/ui/widgets/src/ui/widgets/loading-spacer.vue"],"names":[],"mappings":";AAKA;CACA,iBAAA;CACA","file":"loading-spacer.vue","sourcesContent":["<template>\r\n\t<div class=\"loading-spacer mt-3 d-flex align-items-center\">{{'loading' | format-message}}</div>\r\n</template>\r\n\r\n<style>\r\n\t.loading-spacer {\r\n\t\tmin-height: 5rem;\r\n\t}\r\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ad073d48","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/ui/widgets/loading-spacer.vue
// module id = AGQt
// module chunks = 3